import React from 'react';
import AccessDenied from './AccessDenied';

interface ProtectedRouteProps {
  element: React.ReactElement;
  access?: string;
  isGlobalAdmin?: boolean;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ element, access, isGlobalAdmin }) => {
  // Global admins have access to everything
  if (isGlobalAdmin) {
    return element;
  }

  // Check if user has permission
  // If access is undefined, null, or 'none', deny access
  if (!access || access === 'none') {
    return <AccessDenied />;
  }

  // User has permission, render the page
  return element;
};

export default ProtectedRoute;
